import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { api_routes } from '@app/consts';
import { EnvironmentService } from '@app/core/services/environment.service';
import { map } from 'rxjs/operators';

export class CustomTranslateLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private envService: EnvironmentService
  ) {}

  getTranslation(lang: string): Observable<any> {
    return this.http.get<any>(`${this.envService.env.apiUrl}${api_routes.CULTURES}/${lang}/${api_routes.SYSTEM}`)
      .pipe(
        map(translations => {
          // Remove keys with empty string values
          const filtered = {};
          Object.keys(translations).forEach(key => {
            if (translations[key] && translations[key].trim() !== '') {
              filtered[key] = translations[key];
            }
          });
          return filtered;
        })
      );
  }
}